import React from 'react';
import { Addon } from '@domain/addon';
import { Admission } from '@domain/admission';
import { Event } from '@domain/event';
import { AddGuestResponse } from '@hooks/use-add-guest/use-add-guest';

import { ProcessStepContent } from './components/process-step-content';
import { OfflineSalesForm, ProcessOfflineSalesStep, SaleType } from './process-offline-sales.type';

export interface OfflineSalesStepsProps {
  step: ProcessOfflineSalesStep;
  setStep: (step: ProcessOfflineSalesStep) => void;
  offer?: Admission;
  event?: Event;
  saleType: SaleType;
  quantity: number;
  addGuestData?: AddGuestResponse;
  availableAddons: Addon[];
  selectedAddonIds?: string[];
  email?: string;
  isSubmitting?: boolean;
  closeModal: () => void;
  handleCloseModal: () => void;
  onSubmit: (data: OfflineSalesForm) => void;
}

/*
 * OfflineSalesSteps Component
 *
 * Pure component that renders the specific steps for the Offline Sales process.
 * Receives all data and handlers as props from the parent ProcessOfflineSales component.
 */
export const OfflineSalesSteps: React.FC<OfflineSalesStepsProps> = (props) => {
  return <ProcessStepContent {...props} />;
};
